import { render, staticRenderFns } from "./FunConfigDia.vue?vue&type=template&id=a03a340a&scoped=true"
import script from "./FunConfigDia.vue?vue&type=script&lang=js"
export * from "./FunConfigDia.vue?vue&type=script&lang=js"
import style0 from "./FunConfigDia.vue?vue&type=style&index=0&id=a03a340a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a03a340a",
  null
  
)

export default component.exports